import AOS from "aos";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, replaceSvgImages, lazyLoad, countUpInit } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	replaceSvgImages();
	FAQ();
	buttonToTop();
	countUpInit();
	hoverItem();
	hoverItemAdvantage();
	clearSearch();
	dotAnimation();
	// mouseEffect();
	lazyLoad();
	soundAudio();
});

/*==================== Aos Init ====================*/
setTimeout(() => {
	AOS.init({
		// once: true,
		offset: 100,
		easing: 'ease-out-cubic',
	});
}, 100);

// Lazy load
document.addEventListener('DOMContentLoaded', () => {
	lazyLoad();
});

// Lazy load FacetWP
document.addEventListener('facetwp-loaded', () => {
	lazyLoad();
});

/*==================== FAQ =================*/

function FAQ() {
	jQuery(document).ready(function ($) {
		$('.wrap-faq').each(function () {
			let $faq = $(this);
			// Ẩn toàn bộ nội dung và set icon xuống
			$faq.find('.item .wrap-content').hide();
			$faq.find('.item .icon i')
				.removeClass('fa-angle-up')
				.addClass('fa-angle-down');
			// Mở item đầu tiên
			$faq.find('.item:first').addClass('active');
			$faq.find('.item:first .wrap-content').show();
			$faq.find('.item:first .icon i')
				.removeClass('fa-angle-down')
				.addClass('fa-angle-up');
			// Click toggle
			$faq.find('.item .wrap-heading').on('click', function () {
				let $item = $(this).closest('.item');
				let $content = $item.find('.wrap-content');
				let $icon = $item.find('.icon i');

				if ($item.hasClass('active')) {
					$item.removeClass('active');
					$content.slideUp();
					$icon.removeClass('fa-angle-up').addClass('fa-angle-down');
				} else {
					$faq.find('.item').removeClass('active');
					$faq.find('.item .wrap-content').slideUp();
					$faq.find('.item .icon i')
						.removeClass('fa-angle-up')
						.addClass('fa-angle-down');

					$item.addClass('active');
					$content.slideDown();
					$icon.removeClass('fa-angle-down').addClass('fa-angle-up');
				}
			});
		});
	});
}

function hoverItem() {
	document.querySelectorAll('.section .item').forEach(item => {
		const desc = item.querySelector('.desc');
		desc.style.maxHeight = '0';
		desc.style.transform = 'translateY(10px)';
		desc.style.transition = 'all 0.5s ease';

		item.addEventListener('mouseenter', () => {
			desc.style.maxHeight = desc.scrollHeight + 'px';
			desc.style.opacity = '1';
			desc.style.transform = 'translateY(0)';
		});

		item.addEventListener('mouseleave', () => {
			desc.style.maxHeight = '0';
			desc.style.opacity = '0';
			desc.style.transform = 'translateY(10px)';
		});
	});
}

function hoverItemAdvantage() {
	$('.list-advantage .item').on('mouseenter', function () {
		$(this).addClass('active').siblings().removeClass('active');
	});
}

function clearSearch() {
	$(document).on('click', '.btn-close', function () {
		$('.search-form input').val('');
		$('.btn-close').hide();
	});
	$(document).on('keyup', '.search-form input', function (e) {
		let val = $(this).val().trim();
		if (val.length > 0) {
			$('.btn-close').show();
		} else {
			$('.btn-close').hide();
		}
	});
}

function dotAnimation() {
	const dots = document.querySelectorAll('svg .dot');

	dots.forEach(dot => {
		const chance = Math.random();
		if (chance > 0.7) {
			dot.classList.add('hidden-dot');
		} else {
			dot.classList.remove('hidden-dot');
		}
	});

	setTimeout(dotAnimation, 300);
}

function mouseEffect() {
	let ww = window.innerWidth;
	let wh = window.innerHeight;

	let movexTarget = 0, moveyTarget = 0;
	let movexCurrent = 0, moveyCurrent = 0;

	let easingFactor = 0.1;

	document.addEventListener('mousemove', event => {
		let mx = event.clientX / ww;
		let my = event.clientY / wh;

		movexTarget = (0.5 - mx) * -2;
		moveyTarget = (0.5 - my) * -2;
	});

	function updateMotion() {
		movexCurrent += (movexTarget - movexCurrent) * easingFactor;
		moveyCurrent += (moveyTarget - moveyCurrent) * easingFactor;

		document.documentElement.style.setProperty('--movex', movexCurrent.toFixed(3));
		document.documentElement.style.setProperty('--movey', moveyCurrent.toFixed(3));

		requestAnimationFrame(updateMotion);
	}

	updateMotion();
}

function soundAudio() {
	$(".icon-voice").on("click", function () {
		var audioEl = $(this).find("audio")[0];
		if (audioEl) {
			audioEl.currentTime = 0;

			audioEl.play().catch(function (error) {
				console.error("error", error);
			});
		}
	});
}


document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);
	ScrollTrigger.matchMedia({
		"(min-width: 1023px)": function () {

			const section = document.querySelector('.section-about-3');
			if (!section) return;
			const items = section.querySelectorAll('.list-timeline .item');

			// Tạo Timeline chính
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: "top top",
					// GIẢM SỐ NÀY: Thay 500 bằng 250 (nhanh gấp đôi)
					end: `+=${items.length * 250}`,
					pin: true,
					scrub: 0.5, // Giảm scrub để hiệu ứng bám sát chuột hơn (tạo cảm giác nhanh hơn)
					markers: false
				}
			});

			// Loop qua từng item
			items.forEach((item, index) => {
				const lineImage = item.querySelector('.line .image');
				const content = item.querySelector('.content');

				// Hiệu ứng 1
				tl.from(lineImage, {
					height: 0,
					duration: 1, // Giảm duration nội bộ nếu cần timeline "ngắn gọn" hơn về tỉ lệ
					ease: "none"
				});

				// Hiệu ứng 2
				tl.from(content, {
					y: 50,
					autoAlpha: 0,
					duration: 1,
					ease: "power2.out"
				}, "<+0.1"); // Giảm độ trễ start
			});

		}
	});
});

// document.addEventListener("DOMContentLoaded", function () {
// 	gsap.registerPlugin(ScrollTrigger);
// 	const section = document.querySelector('.section-about-3');
// 	const items = section.querySelectorAll('.list-timeline .item');
// 	// Tạo Timeline chính
// 	const tl = gsap.timeline({
// 		scrollTrigger: {
// 			trigger: section,
// 			start: "top top",
// 			end: `+=${items.length * 500}`,
// 			pin: true,
// 			scrub: 1,
// 			markers: false
// 		}
// 	});

// 	items.forEach((item, index) => {
// 		const lineImage = item.querySelector('.line .image');
// 		const content = item.querySelector('.content');

// 		tl.from(lineImage, {
// 			height: 0,
// 			duration: 2, // Thời lượng tương đối trong timeline
// 			ease: "none" // Linear để line chạy đều theo tốc độ cuộn
// 		});

// 		tl.from(content, {
// 			y: 50,
// 			autoAlpha: 0,
// 			duration: 1.5,
// 			ease: "power2.out"
// 		}, "<+0.2");
// 		// "<+0.2": Bắt đầu cùng lúc với hiệu ứng Line ở trên (nhưng trễ 0.2s cho tự nhiên)

// 		// Thêm khoảng nghỉ nhỏ giữa các item (nếu muốn item sau chờ item trước xong hẳn)
// 		// tl.to({}, { duration: 0.5 });
// 	})

// });

